{
  "collapse": "Colapsar",
  "expand": "Expandir"
}
